import styled from 'styled-components'

export const Container = styled.div`
  margin: 20px 0;
  padding: 20px 20px 0;
  background: ${props => props.theme.palette.general.soft};

  &:last-child {
    margin-bottom: 0;
  }
`

export const ProductData = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0 20px;
`

export const ProductName = styled.div`
  font-size: 14px;
  font-weight: ${props => props.theme.font.default.bold};
  margin: 0 0 0 20px;
`

export const Image = styled.div`
  border: 1px solid ${props => props.theme.palette.general.greyLight};
  padding: 5px;
  background: ${props => props.theme.palette.general.light};

  > div {
    width: 75px;
    height: 75px;
    background: no-repeat 50% 50% / contain;
  }
`
